import React from 'react';
import { IconSvgProps } from '@models/common';
import styles from './ChevronsRight.module.scss';

const VIEW_BOX_WIDTH = 20.5358;
const VIEW_BOX_HEIGHT = 11.7391;

// Three right chevrons with a looping opacity "run"; `size` sets the width.
const ChevronsRight: React.FC<IconSvgProps> = (props) => {
  const { size = 19, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={
        typeof size === 'number'
          ? (size * VIEW_BOX_HEIGHT) / VIEW_BOX_WIDTH
          : undefined
      }
      fill='none'
      viewBox={`0 0 ${VIEW_BOX_WIDTH} ${VIEW_BOX_HEIGHT}`}>
      <g
        stroke='currentColor'
        strokeWidth='1.73913'
        strokeLinecap='round'
        strokeLinejoin='round'>
        <path
          className={styles.chevron}
          opacity='0.28'
          d='M0.869567 0.869566L5.97566 5.97373L0.869567 10.8696'
        />
        <path
          className={styles.chevron}
          opacity='0.55'
          d='M7.71492 0.869568L12.821 5.97374L7.71492 10.8696'
        />
        <path
          className={styles.chevron}
          d='M14.5601 0.869568L19.6662 5.97374L14.5601 10.8696'
        />
      </g>
    </svg>
  );
};

export default ChevronsRight;
